import { render } from "./reportBanner.vue?vue&type=template&id=136a4f78&ts=true"
import script from "./reportBanner.vue?vue&type=script&lang=ts&config=true"
export * from "./reportBanner.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__